import NumberSelect from '@components/numberSelect';
import generateGUID from 'utils/guidGenerator';

const OPTIONS = ['Any', '1', '2', '3', '4', '5+'];

/**
 * Bedrooms filter — number select (Any/1/2/3/4/5+) (Figma "Bedrooms" field), built on the
 * generic `@components/numberSelect` and its Smart Range Selection interaction. "Any" is the
 * pre-applied default.
 *
 * Only produces markup (`getHtml`) and binds behavior to the element the calling control created
 * from it (`new BedroomsFilter(element)`); it never creates DOM itself.
 */
export default class BedroomsFilter {
  static getSelector() {
    return '[data-bedrooms-filter]';
  }

  static getHtml() {
    const labelId = `bedrooms-label-${generateGUID()}`;
    const numberSelectHtml = NumberSelect.getHtml({
      options: OPTIONS,
      automationIdentifier: 'bedrooms_filter',
      labelledBy: labelId,
    });

    return `
      <div class="nhs-c-input__wrapper nhs-c-input__wrapper--filter" data-bedrooms-filter>
        <p class="nhs-c-input__label nhs-c-input__label--book" id="${labelId}">Bedrooms</p>
        ${numberSelectHtml}
      </div>
    `;
  }

  constructor(element) {
    this.element = element;
    this.numberSelect = new NumberSelect(element.querySelector(NumberSelect.getSelector()));
  }

  getObservable() {
    return this.numberSelect.getObservable();
  }

  // Syncs the buttons to an externally-known value (e.g. the store's current filter, read back
  // when the modal reopens) without emitting — this reflects state that already exists, it isn't
  // a new user click to emit.
  setValue({ min, max }) {
    this.numberSelect.setState({ min, max });
  }

  destroy() {
    this.numberSelect.destroy();
  }
}
